import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10 7.75A.75.75 0 0 1 9.25 7V5.75H7a.25.25 0 0 0-.25.25v11c0 .138.112.25.25.25h13a.25.25 0 0 0 .25-.25V6a.25.25 0 0 0-.25-.25h-2.25V7a.75.75 0 0 1-1.5 0V5.75h-5.5V7a.75.75 0 0 1-.75.75m6.25-3.5h-5.5V3a.75.75 0 0 0-1.5 0v1.25H7A1.75 1.75 0 0 0 5.25 6v.25H4A1.75 1.75 0 0 0 2.25 8v12c0 .966.784 1.75 1.75 1.75h13A1.75 1.75 0 0 0 18.75 20v-1.25H20A1.75 1.75 0 0 0 21.75 17V6A1.75 1.75 0 0 0 20 4.25h-2.25V3a.75.75 0 0 0-1.5 0zm-11 3.5V17c0 .966.784 1.75 1.75 1.75h10.25V20a.25.25 0 0 1-.25.25H4a.25.25 0 0 1-.25-.25V8A.25.25 0 0 1 4 7.75z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }